// Programmes data moved from pages.js

export const CS_PROGRAMME_HERO = {
    badge: "India's First AI-Powered CS Ecosystem",
    headline: "Computer Science + AI (4-Year Program)",
    description:
        "A full undergraduate degree in Computer Science, redesigned with AI-integrated curriculum, real-world projects, AI assistant available 24/7, and placement support from Semester 1.",
    pills: [
        "Computer Science",
        "40+ Real Projects",
        "Guaranteed Internship",
        "1800+ Hiring Partners",
        "CMU-Standard Curriculum",
    ],
    features: [
        "🎓︎ 4-year cs degree",
        "🌐︎ Partnered universities",
        "💼︎ Placement support included",
    ],
    ctaPrimary: "Reserve Seat",
    heroImage:
        "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=2670&auto=format&fit=crop",
};

export const CS_PROGRAMME_HERO_US = {
    badge: "AI-Powered Computer Science Ecosystem",
    headline: "Computer Science + AI (4-Year B.S. Program)",
    description:
        "A full undergraduate degree in Computer Science, redesigned with AI-integrated curriculum, real-world projects, AI assistant available 24/7, and career support from Semester 1.",
    pills: [
        "Computer Science",
        "40+ Real Projects",
        "Guaranteed Internship",
        "1,800+ Hiring Partners",
        "Silicon Valley Aligned Curriculum",
    ],
    features: [
        "🎓︎ 4-Year B.S. Degree",
        "🌐︎ Partnered Universities",
        "💼︎ Career Support Included",
    ],
    ctaPrimary: "Reserve Your Spot",
    heroImage:
        "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=2670&auto=format&fit=crop",
};

export function getCSProgrammeHero(country) {
    if (country === "US") return CS_PROGRAMME_HERO_US;
    return CS_PROGRAMME_HERO;
}

export const CS_PROGRAMME_STATS = [
    { num: "40+", label: "Projects in portfolio" },
    { num: "1800+", label: "Hiring partners" },
    { num: "100%", label: "Guaranteed internship" },
    { num: "24/7", label: " AI Learning assistance" },
    // { num: "4 yrs", label: "Lifelong career support" },
];

export const CS_PROGRAMME_OFFERINGS = {
    tag: "Learning Pathways",
    headline:
        'Choose your specialization. <br/><span className="text-aiblue">Every path leads to a future worth building.</span>',
    subtext:
        "Built on a future - ready AI foundation, every specialization transforms ambition into skills, innovation, and real - world impact.",
    badgeMostPopular: "Most Popular",
    cta: "Reserve Your Spot",
    offerings: [
        {
            name: "Artificial Intelligence & Machine Learning",
            desc: "Build the systems that power the world's smartest products",
            featured: true,
        },
        {
            name: "Data Science",
            desc: "Turn data into decisions that companies pay top dollar for",
            featured: false,
        },
        {
            name: "Cyber Security",
            desc: "Protect the systems that the digital world depends on",
            featured: false,
        },
        {
            name: "Computer Science & Engineering",
            desc: "Broad CS foundations with AI tools baked in from day one",
            featured: false,
        },
        {
            name: "Information Technology",
            desc: "Enterprise-grade IT skills paired with modern AI competence",
            featured: false,
        },
    ],
};

export const CS_PROGRAMME_YEARS_SECTION = {
    tag: "The 4-Year Journey",
    headline: "A clear picture of exactly what happens each year",
    description:
        "Each year compounds on the last. No semester is filler — every milestone produces verifiable proof a recruiter can audit.",
};

export const CS_PROGRAMME_YEARS = [
    {
        n: 1,
        title: "Year 1",
        tagline: "AI-Native Foundation",
        accentColor: "blue",
        image: "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
        bullets: [
            "Go from complete beginner to a <strong><span style='color:#0052FF'>confident AI-native developer</span></strong> with a 24/7 personal AI learning co-pilot that adapts to your pace and learning style.",
            "Build a <strong><span style='color:#0052FF'>verified professional portfolio</span></strong> from your very first year — showcasing real projects most students never create during an entire degree.",
        ],
    },
    {
        n: 2,
        title: "Year 2",
        tagline: "Applied Engineering",
        accentColor: "orange",
        image: `${process.env.PUBLIC_URL}/general/learnWithAI.png`,
        bullets: [
            "Gain <strong><span style='color:#FF6B00'>real industry experience early</span></strong> through guaranteed internships and hands-on exposure to how modern tech companies operate.",
            "Progress from writing basic code to building <strong><span style='color:#FF6B00'>scalable, production-ready systems</span></strong> designed for real-world impact.",
        ],
    },
    {
        n: 3,
        title: "Year 3",
        tagline: "Advanced Mastery",
        accentColor: "orange",
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&q=85&w=800",
        bullets: [
            "Master <strong><span style='color:#FF6B00'>Generative AI, cloud infrastructure, and advanced LLM engineering</span></strong> through immersive, project-based learning.",
            "Sharpen your technical thinking with <strong><span style='color:#FF6B00'>live AI-driven assessments and architecture challenges</span></strong> designed to prepare you for real engineering roles.",
        ],
    },
    {
        n: 4,
        title: "Year 4",
        tagline: "Predictable Placements",
        accentColor: "blue",
        image: `${process.env.PUBLIC_URL}/general/placed.png`,
        bullets: [
            "Graduate with a <strong><span style='color:#0052FF'>verified Tech Readiness Score</span></strong> and direct visibility to a network of 1,800+ hiring partners.",
            "Prepare for top opportunities through <strong><span style='color:#0052FF'>personalized mock interviews, career coaching, and long-term placement support</span></strong> designed to accelerate your growth beyond graduation.",
        ],
    },
];

export const CS_VEDA_SECTION = {
    tag: "Meet Veda",
    headline:
        "A personal AI mentor that learns, guides, and grows with every student",
    description:
        "Students shouldn’t have to wait for help, clarity, or feedback. From late-night debugging sessions to exam preparation and interview practice, intelligent support is available whenever learning happens.",
    features: [
        {
            icon: "📖",
            title: "Teaches at their pace",
            desc: "Veda adapts in real-time to each student's gaps, strengths, and goals.",
            color: "bg-white/20",
        },
        {
            icon: "💻",
            title: "Real-time coding guidance",
            desc: "Stuck on an error at 11pm? your learning assistant veda works through it step by step.",
            color: "bg-white/15",
        },
        {
            icon: "🎧",
            title: "Technical assessments",
            desc: "Interactive voice based evaluations designed to measure problem-solving, critical thinking, and true conceptual understanding.",
            color: "bg-white/20",
        },
        {
            icon: "💼",
            title: "Coaches for placement",
            desc: "Mock interviews, resume feedback, and personalized skill insights to prepare students for top opportunities.",
            color: "bg-white/15",
        },
    ],
};

export const CS_PLACEMENT_SECTION = {
    tag: "Placements",
    headline:
        "Students graduate with proof of skill — not just with a degree",
    description:
        "Every project, assessment, and technical milestone builds a verified profile that companies can trust. By graduation, students don’t just apply for opportunities — they stand out for them.",
    metrics: [
        { num: "1800+", desc: "Companies in the hiring network" },
        { num: "3000+", desc: "Hiring partners projected by 2027" },
        {
            num: "40+",
            desc: "Real-world projects built across the program",
        },
    ],
    timeline: [
        {
            title: "Industry-ready portfolios",
            desc: "Students build a strong portfolio of real projects that showcases practical skills, creativity, and execution.",
        },
        {
            title: "Internships with real exposure",
            desc: "Hands-on industry experience through internships designed to bridge learning with real-world engineering environments.",
        },
        {
            title: "Verified technical proficiency",
            desc: "Continuous assessments, advanced projects, and AI-driven evaluations help students develop production-level skills.",
        },
        {
            title: "Direct access to hiring opportunities",
            desc: "Students gain visibility to a large hiring network through verified profiles, placement support, and career preparation.",
        },
    ],
};
export const CS_CMU_SECTION = {
    tag: "Elite Global Network",
    headline: "The World's Top AI Builders.",
    description: "Unlocking your potential.",
    cards: [
        {
            tag: "RIGOR",
            num: "1",
            title: "The Global AI Standard",
            desc: "The exact rigor that trains the world's elite AI engineers. Directly curated and architected by top researchers from CMU, Stanford, and MIT.",
            img: `${process.env.PUBLIC_URL}/general/RIGOR.png`,
            accent: "bg-blue-500",
        },
        {
            tag: "CRAFT",
            num: "2",
            title: "Silicon Valley, live in class",
            desc: "Engineers who've shipped products used by billions don't give guest lectures. They teach — real problems, real tools, real conversations.",
            img: `${process.env.PUBLIC_URL}/general/CRAFT.png`,
            accent: "bg-orange-500",
        },
        {
            tag: "CONTEXT",
            num: "3",
            title: "The people building AI's future",
            desc: "Founders and leaders of the companies reshaping the world teach exclusively for you — straight from the source.",
            img: `${process.env.PUBLIC_URL}/general/CONTEXT.png`,
            accent: "bg-green-500",
        },
    ],
};

export const CS_ELIGIBILITY_SECTION = {
    tag: "Admissions",
    headline: "Who should apply?",
    subtext: "Two paths. One ecosystem. Built to deliver.",
    cards: [
        {
            icon: "🎓",
            tag: "FOR STUDENTS",
            title: "12th Pass with PCM",
            desc: "Students who have completed or are completing Class 12 with Physics, Chemistry, and Mathematics from any recognised board. No JEE required — admission is merit and profile based.",
            checklist: [
                "Class 12 pass from any recognised board",
                "Physics, Chemistry, Mathematics — mandatory",
                "No JEE score required",
                "Curiosity, drive, and readiness to build",
            ],
            accent: "aiblue",
            cta: "Reserve Seat",
        },
        {
            icon: "🏛️",
            tag: "FOR UNIVERSITIES",
            title: "Engineering Colleges",
            desc: "Engineering colleges and universities offering or planning to offer Computer Science programmes. Bring the AI.Prof ecosystem into your institution and transform your students' outcomes.",
            checklist: [
                "Engineering college or university",
                "CS / IT programme (existing or planned)",
                "Commitment to student placement excellence",
                "Infrastructure for modern tech education",
            ],
            accent: "aiorange",
            cta: "Partner as an Institute",
        },
    ],
};

export const CS_ELIGIBILITY_SECTION_US = {
    tag: "Admissions",
    headline: "Who should apply?",
    subtext: "Two paths. One ecosystem. Built to deliver.",
    cards: [
        {
            icon: "🎓",
            tag: "FOR STUDENTS",
            title: "High School Diploma (STEM / Math Track)",
            desc: "Students who have completed or are earning their High School Diploma or GED with foundational math and science coursework. No SAT / ACT required — admission is holistic and portfolio-based.",
            checklist: [
                "High School Diploma or GED from an accredited school",
                "Foundational Math (Algebra II / Pre-Calc / AP CS) — recommended",
                "No SAT / ACT scores required (Test-Optional)",
                "Curiosity, drive, and readiness to build",
            ],
            accent: "aiblue",
            cta: "Reserve Your Spot",
        },
        {
            icon: "🏛️",
            tag: "FOR COLLEGES & UNIVERSITIES",
            title: "Higher Education Institutions",
            desc: "Accredited colleges and universities offering or planning to launch Computer Science and Software Engineering degree programs. Integrate our AI-Powered Tech Ecosystem into your institution and elevate student career outcomes.",
            checklist: [
                "Accredited 4-year college or university",
                "CS / Software Engineering program (existing or planned)",
                "Commitment to career outcomes & industry placement",
                "Infrastructure for hands-on, modern tech education",
            ],
            accent: "aiorange",
            cta: "Partner as an Institution",
        },
    ],
};

export function getEligibilityContent(country) {
    if (country === "US") return CS_ELIGIBILITY_SECTION_US;
    return CS_ELIGIBILITY_SECTION;
}

export const CS_CTA = {
    headline1: "The AI era isn't coming.",
    headline2: "It's already here.",
    description:
        "The world is being rebuilt by AI, and innovation. The real advantage belongs to those students who start early, build deeply, and stay ahead of change. The program that closes that gap starts with one decision.",
    ctaPrimary: "Reserve Seat Now",
    ctaSecondary: "Download Full Brochure",
    faqTag: "Frequently Asked",
    faqHeadline:
        'Your Questions, <span className="text-aiblue">Answered</span>',
};

export const PROGRAMMES_PAGE = {
    tag: "Programmes",
    headlineLead: "Every track is built",
    headlineHighlight: "to make you hireable.",
    description:
        "Not just educated. Hireable. Real projects. Real tools. Real industry mentorship — from Day 1.",
    faqTag: "Got Questions?",
    faqHeadline: `We've got <span className="text-aiblue">answers.</span>`,
};

export const DOMAIN_IMAGES = {
    "Artificial Intelligence & Machine Learning":
        "https://images.unsplash.com/photo-1677442136019-21780ecad995?q=80&w=2670&auto=format&fit=crop",
    "Data Science":
        "https://images.unsplash.com/photo-1551288049-bebda4e38f71?q=80&w=2670&auto=format&fit=crop",
    "Cyber Security":
        "https://s44783.pcdn.co/in/wp-content/uploads/sites/3/2023/10/Ethical-Hacking-vs-Cyber-Security-1140x900-1-1024x808.jpg.webp",
    "Computer Science & Engineering":
        "https://images.unsplash.com/photo-1461749280684-dccba630e2f6?q=80&w=2669&auto=format&fit=crop",
    "Information Technology":
        "https://images.unsplash.com/photo-1451187580459-43490279c0fa?q=80&w=2672&auto=format&fit=crop",
};
